// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"23c13480","292":"fc4ab8fe","384":"8776c84c","584":"01e7d6b8","787":"11f37a1b","849":"67c65c45","897":"4beab67a"}[chunkId] + ".chunk.js";
};